import { __decorate } from "tslib";
import { Options, Vue } from "vue-class-component";
let Pagination = class Pagination extends Vue {
    items;
    currentPage;
    pageSize;
};
Pagination = __decorate([
    Options({
        props: {
            items: String,
            currentPage: String,
            pageSize: String,
        },
        data() {
            return {};
        },
        mounted() { },
        methods: {
            updatePage(pageNum) {
                if (pageNum < 0) {
                    pageNum = 0;
                }
                else {
                    this.$emit("page:update", pageNum);
                }
            },
            totalPages() {
                return Math.ceil(this.items.length / this.pageSize);
            },
            showPreviousLink() {
                return this.currentPage == 0 ? false : true;
            },
            showNextLink() {
                return this.currentPage == this.totalPages() - 1 ? false : true;
            },
        },
        computed: {},
    })
], Pagination);
export default Pagination;
